import script from "./BoxItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./BoxItem.vue?vue&type=script&setup=true&lang=ts"

import "./BoxItem.vue?vue&type=style&index=0&id=f3a446ee&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3a446ee"]])

export default __exports__